import { Box } from "@mui/material";

const SUMMARY_TILE_SX = {
  flex: 1,
  border: "1px solid #E8EBF0",
  borderRadius: "10px",
  padding: "14px 16px",
  backgroundColor: "#FAFAFC",
};

function formatPercent(value) {
  const pct = typeof value === "number" ? value : parseFloat(value);
  return Number.isFinite(pct) ? `${pct.toFixed(1)}%` : "-";
}

function SubLeaseWetLeaseExposurePanel({ summary, onRowClick }) {
  if (!summary) return null;
  const tiles = [
    { value: Number.isFinite(summary?.sub_lease_count) ? summary.sub_lease_count : "-", label: "Sub-leases" },
    { value: Number.isFinite(summary?.wet_lease_count) ? summary.wet_lease_count : "-", label: "Wet leases" },
    { value: formatPercent(summary?.portfolio_share_pct), label: "Portfolio share" },
  ];
  const rows = [
    { label: "Sub Lease", value: summary?.sub_lease_asset_count },
    { label: "Wet Lease", value: summary?.wet_lease_asset_count },
  ];
  return (
    <Box sx={{ display: "flex", alignItems: "stretch", gap: 3, py: 1 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, width: "30%", flexShrink: 0 }}>
        {tiles.map((tile) => (
          <Box key={tile.label} sx={SUMMARY_TILE_SX}>
            <Box sx={{ fontSize: 22, fontWeight: 700, color: "#1B2A4A", lineHeight: 1.2 }}>{tile.value}</Box>
            <Box sx={{ fontSize: 13, color: "#8E97A8", mt: 0.5 }}>{tile.label}</Box>
          </Box>
        ))}
      </Box>
      <Box sx={{ flex: "1 1 auto", display: "flex", flexDirection: "column", justifyContent: "center", borderLeft: "1px solid #E8EBF0", pl: 3 }}>
        {rows.map((row, index) => (
          <Box
            key={row.label}
            onClick={onRowClick ? () => onRowClick(row.label) : undefined}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1.5,
              borderBottom: index < rows.length - 1 ? "1px solid #E8EBF0" : "none",
              cursor: onRowClick ? "pointer" : "default",
              "&:hover": onRowClick ? { backgroundColor: "#F5F7FA" } : undefined,
            }}
          >
            <Box sx={{ fontSize: 14, color: "#1B2A4A", textAlign: "left" }}>{row.label}</Box>
            <Box sx={{ fontSize: 14, fontFamily: "monospace", color: "#1B2A4A", textAlign: "right" }}>
              {Number.isFinite(row.value) ? row.value : "-"} assets
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default SubLeaseWetLeaseExposurePanel;
